import { render, staticRenderFns } from "./PidPendingNearMatchTable.vue?vue&type=template&id=07ec2885&scoped=true&"
import script from "./PidPendingNearMatchTable.vue?vue&type=script&lang=js&"
export * from "./PidPendingNearMatchTable.vue?vue&type=script&lang=js&"
import style0 from "./PidPendingNearMatchTable.vue?vue&type=style&index=0&id=07ec2885&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07ec2885",
  null
  
)

export default component.exports